import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PATHS } from "../utils";

const TitleManager = () => {
  const location = useLocation();

  useEffect(() => {
    const { pathname } = location;
    let title = "Stackular";

    if (pathname === PATHS.about) {
      title = "About - Stackular";
    } else if (pathname === PATHS.services || pathname.startsWith(`${PATHS.services}/`)) {
      title = "Services - Stackular";
    } else if (pathname === PATHS.industries || pathname.startsWith(`${PATHS.industries}/`)) {
      title = "Industries - Stackular";
    } else if (pathname === PATHS.portfolio || pathname.startsWith(`${PATHS.portfolio}/`)) {
      title = "Portfolio - Stackular";
    } else if (pathname === PATHS.joinUs) {
      title = "Join Us - Stackular";
    } else if (pathname === PATHS.contactUs) {
      title = "Contact Us - Stackular";
    } else if (pathname === PATHS.privacyPolicy) {
      title = "Privacy Policy - Stackular";
    } else if (pathname === PATHS.frontpage || pathname === PATHS.home) {
      title = "Home - Stackular";
    }

    document.title = title;
  }, [location]);

  return null;
};

export default TitleManager;


